<template>
  <section aria-labelledby="disclosure-heading">
    <div class="container mt-4 fullPage">
      <div class="row">
        <h1 id="disclosure-heading" class="display-1 mb-4 page-title">
          <span class="heading_bdr_btm">
           Mandatory Disclosure
          </span>
        </h1>
        <h2 class="text-left mb-0 firm-name"><strong>GROW WITH STOCKS</strong></h2>
        <div class="contact-info">
            <p class="mt-0"><strong>SEBI Registered Research Analyst:</strong> INH000001212 <br/>
            <strong>BSE Enlistment Number:</strong> 5078 <br/>
            <strong>Founder & Principal Officer:</strong> Goutam Sharma <br/>
            <strong>Email:</strong> growwithstocks@gmail.com / info@growwithstocks.com <br/>
            <strong>Contact:</strong> +91 9271212131 <br/>
            <strong>Address:</strong> 120, Shastri Nagar, Jammu - 180004</p>
        </div>

        <h2 class="text-left mb-3 section-lead">Disclosure As Per Securities And Exchange Board Of India (Research Analysts) Regulations, 2014</h2>

        <div class="section">
            <h2 class="text-left section-sub">Disclosure with regard to ownership and material conflicts of interest</h2>
            <p>The Research Analyst or their relatives or associates do not have financial interest in the subject company.</p>
            <p>The Research Analyst or their relatives or associates do not have actual/beneficial ownership of 1% or more securities of the subject company at the end of the month immediately preceding the date of publication of the research report.</p>
            <p>The Research Analyst or their relatives or associates do not have any other material conflict of interest at the time of publication of the research report.</p>
        </div>

        <div class="section">
            <h2 class="text-left section-sub">Disclosure with regard to receipt of Compensation</h2>
            <p>The Research Analyst or their associates have not received compensation from the subject company in the past 12 months.</p>
            <p>The Research Analyst or their associates have not managed or co-managed a public offering of securities for the subject company in the past 12 months.</p>
            <p>The Research Analyst or their associates have not received any compensation for investment banking, merchant banking, or brokerage services from the subject company in the past 12 months.</p>
            <p>The Research Analyst or their associates have not received compensation or other benefits from the subject company or third party in connection with the research report.</p>
        </div>

        <div class="section">
            <h2 class="text-left section-sub">General Disclosure</h2>
            <p>The Research Analyst has not served as an officer, director, or employee of the subject company.</p>
            <p>The Research Analyst has not been engaged in market-making activity for the subject company.</p>
        </div>

        <div class="section">
            <h2 class="text-left section-sub">Use of AI Tools in Providing research services</h2>
            <p>No AI Tools are used in generating research reports or recommendations.</p>
        </div>

        <div class="section">
            <h2 class="section-sub">Warning</h2>
            <p>“Investments in securities market are subject to market risks. Read all the related documents carefully before investing.”</p>
        </div>

        <div class="section disclaimer">
            <h2 class="text-left section-sub">Disclaimer</h2>
            <p>“Registration granted by SEBI, membership of a SEBI recognized supervisory body (if any) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.”</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "MandatoryDisclosure",
    mounted() {
      document.title = "Mandatory Disclosure | Grow With Stocks";
    }
  };
</script>

<style lang="scss" scoped>
  .page-title {
    text-align: center;
    color: #1a1a1a;
    font-weight: 700;
  }
  .firm-name {
    font-size: 20px;
    color: #1a1a1a;
    font-weight: 700;
    margin-top: 16px;
  }
  .section-lead {
    font-size: 22px;
    color: #1a1a1a;
    font-weight: 700;
    margin-top: 24px;
  }
  .section-sub {
    font-size: 18px;
    font-weight: 700;
    color: #1a1a1a;
    margin-top: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/views/MandatoryDisclosure.vue